<template>

  <!-- Student Happiness Index Question -->
  <div id="notification-5" class="notification-box" :class="promptHI">
    <div class="notification-dialog android-style">
      <div class="notification-header">
        <div class="in">
          <img src="img/logo_HI.png" alt="image" class="imaged w24 rounded">
          <strong>Notifikasi</strong>
          <span>Sebentar tadi</span>
        </div>
        <a href="#" class="close-button" @click="closeStudentHappiness">
          <ion-icon name="close"></ion-icon>
        </a>
      </div>
      <div class="notification-content">
        <div class="in">
          <h3 class="subtitle">Happiness Index!</h3>
          <div class="text">
            Anda mempunyai soalan yang perlu dijawab yang bertujuan untuk mengukur Indeks Kegembiraan warga UiTM
          </div>
        </div>
      </div>
      <div class="notification-footer">
        <a href="#" class="notification-button" @click="openStudentHappinessIndex">
          <ion-icon name="help-circle-outline"></ion-icon>
          Jawab Soalan
        </a>
      </div>
    </div>
  </div>
  <!-- * Student Happiness Index Question -->

  <div v-if="initialLoading" class="page-loading-overlay">
    <div class="d-flex justify-content-center align-items-center h-100">
      <div class="spinner-border text-primary" role="status"><span class="visually-hidden">Loading...</span></div>
    </div>
  </div>

  <div class=" bg-section-profile" v-show="!initialLoading">
    <div class="section pt-3">
      <div class="profile-head justify-content-end mb-3">
        <div class="in">
          <h3 class="subtext">Hai,</h3>
          <h5 class="name">{{currentUser.name}}</h5>
        </div>
        <div class="avatar">
          <img class="imaged w64 rounded" :src="currentUser.picture" alt="avatar">
        </div>
      </div>
    </div>

    <div class="section mb-2">
      <div class="card rounded-4 text-center">
        <ul id="scroller">
          <li class="menu-bar" v-if="sulung">
            <router-link to="/sulung" class="item-app btn-icon">
              <img src="img/btn/sulung.png" class="button-rounded" alt=sulung>
              <span class="fw-small caption">SULUNG</span>
            </router-link>
          </li>
          <span v-for="(data, index) in this.settings.topmenu" :key="data">
            <li class="menu-bar" v-if="data.showed">
              <router-link :to="data.link" class="item-app btn-icon">
                <img :src="data.img" class="button-rounded" :alt=index>
                <span class="fw-small caption" v-html="data.label"></span>
              </router-link>
            </li>
          </span>
        </ul>
      </div>
    </div>
  </div>

  <div v-if="profilingVisible || asnbVisible" class="section full mb-2">
    <div class="wide-block py-2">
      <div class="card shadow-lg border-0" style="background: linear-gradient(135deg, #6dd5ed 0%, #2193b0 100%); border-radius: 20px;">
        <div class="card-body p-4">
          <button type="button" class="btn-close btn-close-white" @click.prevent="closeProfiling" style="position:absolute; right:18px; top:14px;"></button>
          <div class="text-center mb-2">
            <h4 class="profiling-title text-white font-weight-bold mb-2">{{ profilingVisible ? 'eProfiling - MyHEP &amp; No ASNB (UHID)' : 'No ASNB (UHID)' }}</h4>
            <p v-if="profilingVisible" class="profiling-message text-white mb-0">{{ profilingMessage }}</p>
            <p class="profiling-message text-white mt-1 mb-0">*[Pelajar Ijazah Sarjana Muda Sepenuh Masa Sahaja] Sila lengkapkan No ASNB (UHID) di menu <strong>Pendapatan &amp; Penaja</strong> (Sekiranya belum dikemaskini)</p>
          </div>
          <div class="text-center mt-3" style="border-top: 1px solid rgba(255,255,255,0.08); padding-top:12px;">
            <a v-if="profilingVisible" :href="profilingPautan" target="_blank" rel="noopener noreferrer" class="btn btn-light mb-2">Kemaskini Profil (MyHEP)</a><br v-if="profilingVisible" />
            <router-link to="/sponsor" class="btn btn-light mt-1">Kemaskini Pendapatan &amp; Penaja</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="section m-1 mt-2 mb-0">
    <div class="row">
      <div class="col-6">
        <a name="" id="" class="btn btn-primary btn-block" target="_blank" href="https://units.uitm.edu.my"
          role="button">
          <img src="img/btn/aduanict.png" style="max-height: 35px; padding-right:10px">
          <div style="text-align: left;line-height: 9px;">
            <strong class="text-nowrap text-truncate">Aduan ICT</strong><br />
            <small style="font-size: 7px" class="text-nowrap text-truncate">Adukan masalah ICT anda</small>
          </div>
        </a>
      </div>
      <div class="col-6">
        <a name="" id="" class="btn btn-primary btn-block p-0" target="_blank" href="https://fms.uitm.edu.my"
          role="button">
          <img src="img/btn/aduanfasiliti.png" style="max-height: 35px; padding-right:10px">
          <div style="text-align: left;line-height: 9px;">
            <strong class="text-nowrap text-truncate">Aduan Fasiliti</strong><br />
            <small style="font-size: 7px" class="text-nowrap text-truncate">Adukan masalah fasiliti</small>
          </div>
        </a>
      </div>
    </div>
  </div>
  <div v-if="!settings.homepagevideo" id="carouselExampleIndicators" class="carousel slide p-2"
    data-bs-ride="carousel">
    <div class="carousel-indicators">
      <button type="button" v-for="(data, index) in this.settings.banner" :key="index"
        data-bs-target="#carouselExampleIndicators" :data-bs-slide-to="index" class="active" aria-current="true"
        :aria-label="data.title"></button>
    </div>
    <div class="carousel-inner">
      <div class="carousel-item" :class="(index == 0)?'active':''" v-for="(data, index) in this.settings.banner"
        :key="index">
        <img :src="data.url" class="d-block w-100" :alt="data.title">
        <div class="carousel-caption">
          <h3>{{ data.title }}</h3>
          <p v-html="data.description"></p>
        </div>
      </div>
    </div>
    <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators"
      data-bs-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Previous</span>
    </button>
    <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators"
      data-bs-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Next</span>
    </button>
  </div>
  <div v-else class="section inset m-2 col-12" v-html="settings.homepagevideo">

  </div>

  <div class="section full mb-2">
    <div class="mt-2 p-2 pt-0 pb-0">


      <div class="profile-menu menu-icon">
        <!-- <div class="col-3 d-flex justify-content-center mb-1"> -->
        <a href="https://ufuture.uitm.edu.my" target="_blank" class="item-app">
          <div class="btn-icon iconbtm">
            <img src="img/ufuture.png" alt="image" class="imaged w-100 h-80">
          </div>
          <span class="pt-1 fw-small text-center caption">UFuture</span>
        </a>

        <!-- </div> -->
        <!-- <div class="col-3 d-flex justify-content-center mb-1"> -->
        <a href="https://istudent.uitm.edu.my" target="_blank" class="item-app">
          <div class="btn-icon iconbtm">
            <img src="img/istudent.png" alt="image" class="imaged w-100 h-80">
          </div>
          <span class="pt-1 fw-small text-center caption">iStudent</span>
        </a>

        <a href="/masmed2u" class="item-app">
          <div class="btn-icon iconbtm">
            <img src="img/masmed2u.png" alt="image" class="imaged w-100 h-80">
          </div>
          <span class="pt-1 fw-small text-center caption">MASMED2u</span>
        </a>

        <!-- </div> -->
        <!-- <div class="col-3 d-flex justify-content-center mb-1"> -->
        <router-link to="/iresidensi" class="item-app">
          <div class="btn-icon iconbtm">
            <img src="img/iresidensi.png" alt="image" class="imaged w-100 h-80">
          </div>
          <span class="pt-1 fw-small text-center caption">iResidensi</span>
        </router-link>

        <a href="/ebook" class="item-app">
          <div class="btn-icon iconbtm">
            <img src="img/bukukoku.png" alt="image" class="imaged w-100 h-80">
          </div>
          <span class="pt-1 fw-small text-center caption">Kedai Buku</span>
        </a>

        <!-- </div> -->
        <!-- <div class="col-3 d-flex justify-content-center mb-1"> -->
        <a href="https://mykm.uitm.edu.my/v2/" target="_blank" class="item-app">
          <div class="btn-icon iconbtm">
            <img src="img/kmicon.png" alt="image" class="imaged w-100 h-80">
          </div>
          <span class="pt-1 fw-small text-center caption">PTAR MyKM</span>
        </a>

        <!-- </div> -->
        <!-- <div class="col-3 d-flex justify-content-center mb-1"> -->
        <a href="https://news.uitm.edu.my/" target="_blank" class="item-app">
          <div class="btn-icon iconbtm">
            <img src="img/icon-newshub.png" alt="image" class="imaged w-100 h-80">
          </div>
          <span class="pt-1 fw-small text-center caption">NewsHub</span>
        </a>

        <!-- </div> -->
        <!-- <div class="col-3 d-flex justify-content-center mb-1"> -->
        <a href="https://mysiswa.uitm.edu.my/" target="_blank" class="item-app">
          <div class="btn-icon iconbtm">
            <img src="img/mysiswa.png" alt="image" class="imaged w-100 h-80">
          </div>
          <span class="pt-1 fw-small text-center caption">Kad MySiswa</span>
        </a>

        <!-- </div> -->
        <!-- <div class="col-3 d-flex justify-content-center mb-1"> -->
        <!-- <router-link to="/non_resident" class="item-app">
          <div class="btn-icon iconbtm">
            <img src="img/nonresident.png" alt="image" class="imaged w-100 h-80">
          </div>
          <span class="pt-1 fw-small text-center caption">Non Resident</span>
        </router-link> -->



        <!-- </div> -->
        
        <!-- <router-link to="/kesihatan/medical-form" class="item-app">
          <div class="btn-icon iconbtm">
            <img src="img/medical-icon.svg" alt="medical icon" class="imaged w-100 h-80">
          </div>
          <span class="pt-1 fw-small text-center caption">Borang Perubatan</span>
        </router-link> -->

        <a href="https://www.wasap.my/60355442044/e-AduanHEPUiTM" target="_blank" class="item-app">
          <div class="btn-icon iconbtm">
            <img src="img/aduanHEP.png" alt="image" class="imaged w-100 h-80">
          </div>
          <span class="pt-1 fw-small text-center caption">Aduan HEP</span>
        </a>
      </div>
    </div>
  </div>
  <div id="toast-kad" class="toast-box toast-bottom bg-danger" :class="show">
    <div class="in">
      <div class="text text-white">
        Anda belum membuat persetujuan Kad MySiswa.
      </div>
    </div>
    <router-link to="/kad-prihatin" class="btn btn-sm btn-text text-white btn-outline-light">Teruskan&nbsp;<i
        class="bi bi-arrow-right-short"></i></router-link>
  </div>
  <div id="toast-kad" class="toast-box toast-bottom bg-success" :class="pickup" v-if="settings.kad_siswa == true">
    <div class="in">
      <div class="text text-white">
        Kad MySiswa anda boleh diambil. Sila lihat jadual pengambilan kad.
      </div>
    </div>
    <a :href="jadual" target="_blank" class="btn btn-sm btn-text text-white btn-outline-light">Lihat Jadual&nbsp;<i
        class="bi bi-arrow-right-short"></i></a>
  </div>
  <div id="toast-success" class="toast-box toast-bottom" :class="success">
    <div class="in">
      <ion-icon name="checkmark-circle" class="text-success"></ion-icon>
      <div class="text">
        Data telah berjaya disimpan
      </div>
    </div>
    <button type="button" class="btn btn-sm btn-text-success close-button" @click="success=''">TUTUP</button>
  </div>
  <div id="toast-success" class="toast-box toast-bottom" :class="error">
    <div class="in">
      <ion-icon name="checkmark-circle" class="text-danger"></ion-icon>
      <div class="text">
        Data gagal disimpan
      </div>
    </div>
    <button type="button" class="btn btn-sm btn-text-danger close-button" @click="error = ''">TUTUP</button>
  </div>
  <div class="modal dialogbox" id="DialogPengumuman" data-bs-backdrop="static" tabindex="-1" aria-modal="true"
    role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Pengumuman</h5>
        </div>
        <div class="modal-body pb-0 mb-0">
          <p class="text-justify fw-lighter lh-2 text-wrap" style="text-align: justify" v-html="pengumuman"></p>
        </div>
        <div class="modal-footer pt-0 mt-0">
          <div class="btn-list">
            <a :href="pautan" target="_blank" class="btn btn-text-primary btn-block" v-if="pautannew">Lihat Pautan</a>
            <a :href="pautan" class="btn btn-text-primary btn-block" v-else>Lihat Pautan</a>
            <a href="#" class="btn btn-text-secondary btn-block" data-bs-dismiss="modal" @click="tutup"
              id="myInput">Tutup</a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal dialogbox" id="DialogSponsor" data-bs-backdrop="static" tabindex="-1" aria-modal="true"
    role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Perhatian</h5>
        </div>
        <div class="modal-body pb-0 mb-0">
          <p class="text-justify fw-lighter lh-2 text-wrap" style="text-align: justify">Sila pastikan maklumat berikut
            dilengkapkan untuk meneruskan ke menu lain.</p>

          <ol class="text-left fw-lighter lh-2 text-wrap">
            <li v-for="(msg, index) in blocking_msg" v-bind:key="index">
              <span v-if="msg.title == 'Gambar'" style="font-size: 15px;">Tiada maklumat gambar. Sila kemaskini di <a
                  href="https://kad.uitm.edu.my" target="_blank">sini</a></span>
              <span v-else-if="msg.title == 'Keluarga'" style="font-size: 15px;">Belum mengemas kini maklumat pendapatan
                keluarga dan tajaan/pembiayaan/pinjaman. Sila kemaskini di <router-link to="/sponsor">sini</router-link></span>
              <span v-else style="font-size: 15px;" v-html="msg.remarks"></span>

            </li>
          </ol>
        </div>
        <!-- <div class="modal-footer pt-0 mt-0">
                      <div class="btn-list">
                                <a href="/sponsor" class="btn btn-text-primary btn-block">Kemaskini Maklumat Keluarga</a>
                            </div>
                    </div> -->
      </div>
    </div>
  </div>

  
</template>
<script>
import { Modal } from 'bootstrap'
import UserService from "../services/user.service";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase/index";
import VueCookies from 'vue-cookies';
import HIService from "./../common/hi.service";
//import api from '@/myhep/api';
export default {
  name: 'HomePage',
  data () {
      return {
        initialLoading: true,
        show: '',
        pickup: '',
        success: '',
        error: '',
        settings: '',
        jadual: '',
        pengumuman: '',
        pautan:'',
        sponsor:'',
        blocking:null,
        blocking_msg: [],
        pendapatan: {},
        pautannew: true,
        sulung:false,
        promptHI: '',
        urlHI: '',
        profilingVisible: false,
        asnbVisible: false,
        profilingMessage: 'Sila lengkapkan Profil anda di sistem MyHEP secepat mungkin.',
        profilingPautan: 'https://myhep.uitm.edu.my/',

      }
    },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  created() {
    var success = new URL(location.href).searchParams.get('success') ;
    
    if(success == 'true'){
      this.success = 'show'
    }else if(success == 'false'){
      this.error = 'show'
    }

    this.$store.dispatch("hi/getQuestion")
                        .then(() => {
                          this.checkingHI();
                        })
                        .catch(() => {
                          this.promptHI = 'hide';
                        })
                        .finally(() => {
                        });
    this.checkingHI();
  },
  methods: {
    async checkingHI(){
      if( ( HIService.getFlagHI() === moment().format("YYYYMMDD") && HIService.getFlagAnsweredDB() !== moment().format("YYYYMMDD") )
          && (
            HIService.getFlagAnsweredApp() !== moment().format("YYYYMMDD")
            && HIService.getUrlJWT() !== null
            && HIService.getUrlJWT() !== ''
          )
          ){
          this.promptHI = 'show';
          this.urlHI = HIService.getUrlJWT();
      }else{
        this.promptHI = '';
      }
    },
    async openStudentHappinessIndex(){
      this.promptHI = '';
      HIService.saveFlagAnsweredApp(moment().format("YYYYMMDD"));
      window.open(this.urlHI, "_blank");   
    },
    async closeStudentHappiness(){
      this.promptHI = '';
    },
    closeProfiling () {
      this.profilingVisible = false;
      this.asnbVisible = false;
      VueCookies.set('profiling_popup_shown', 'true', "1d");
    },
    async waitForCurrentUser(timeoutMs = 5000) {
      const interval = 100;
      let waited = 0;
      while (!this.$store.state.auth.user && waited < timeoutMs) {
        await new Promise(r => setTimeout(r, interval));
        waited += interval;
      }
      return !!this.$store.state.auth.user;
    },
    tutup () {
      let myModal = new Modal(document.getElementById('DialogPengumuman'));
      myModal.hide();
      VueCookies.set('papar', 'false', "1d")
    }
  },
  async mounted() {

    /*await api.get('/user').then((response) => {
      console.log(response);
    },
      (error) => {
        this.content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );*/

    
    
    
    await UserService.getPublicContent().then(
      (response) => {
        this.settings = response;
        console.log('[HomePage] settings.homepagevideo:', response.homepagevideo, '| settings.banner:', response.banner);
      },
      (error) => {
        this.content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
    if (this.settings.pengumuman != '' && !VueCookies.isKey('papar')) {
      let myModal = new Modal(document.getElementById('DialogPengumuman'));
      myModal.show();
      this.pengumuman = this.settings.pengumuman
      this.pautan = this.settings.pautan
    }
    // Wait for auth user to be available (store may populate asynchronously)
    const hasUser = await this.waitForCurrentUser(5000);
    if (!hasUser) {
      console.log('No auth user available after wait — skipping profiling check');
      this.initialLoading = false;
    } else {
      // Check profiling_popup flag from pelajar collection and show profiling banner if needed
      try{
        const studentEmail = `${this.$store.state.auth.user.studentid}@student.uitm.edu.my`;
        let pelajarDoc = await getDoc(doc(db, "pelajar", studentEmail));
        if(pelajarDoc.exists()){
          const pdata = pelajarDoc.data();
          // Accept boolean true, string 'true', or numeric 1 for the flag
          const popupFlag = pdata.profiling_popup;
          const showFlag = popupFlag === true || popupFlag === 'true' || popupFlag === 1 || popupFlag === '1';
          console.log('profiling_popup value:', popupFlag, 'cookieExists:', VueCookies.isKey('profiling_popup_shown'));
          // Allow URL override for testing: ?showProfiling=1
          const urlOverride = new URL(location.href).searchParams.get('showProfiling') === '1';
          // Show banner when profiling flag is true regardless of existing cookie
          if (!VueCookies.isKey('profiling_popup_shown')) {
            this.asnbVisible = true;
          }
          if(showFlag || urlOverride){
            this.profilingMessage = pdata.profiling_message || this.profilingMessage;
            this.profilingPautan = pdata.profiling_pautan || this.profilingPautan;
            this.profilingVisible = true;
            console.log('profilingVisible set true for', this.$store.state.auth.user && this.$store.state.auth.user.studentid);
          } else {
            console.log('profiling banner not shown; showFlag=', showFlag);
          }
        } else {
          console.log('pelajar document not found for', studentEmail);
        }
      }catch(err){
        console.error('Error checking profiling_popup:', err);
      } finally {
        // hide initial loading overlay after profiling check completes (whether success or error)
        this.initialLoading = false;
      }
    }

    let docSnap = await getDoc(doc(db, "sulong", this.$store.state.auth.user.studentid));
    
    if (docSnap.exists()) {
      if(docSnap.data().accept == false){
        let myModal = new Modal(document.getElementById('DialogPengumuman'));
        myModal.show();
        this.pengumuman = '<p>السلام عليكم ورحمة الله وبركاته & Salam Sejahtera<br>Saudara/Saudari Pelajar</p><p><strong>TAWARAN MENGIKUTI PROGRAM PEMBANGUNAN SISWA SULUNG 3.0 SESI 2024 / 2025</strong></p><p>Tahniah! Sukacita saudara / saudari pelajar telah terpilih sebagai penerima manfaat Program Pembangunan Siswa Sulung 3.0 bagi sesi 2024 / 2025. Klik pada butang Lihat Pautan dibawah untuk maklumat lengkap tawaran.</p>'
        this.pautan = '/sulung'
        this.pautannew = false

      }
       
      this.sulung = true
    } 

    let updatePendapatan = false;
    this.user = await getDoc(
      doc(db, "maklumatPendapatanPelajar", `${this.$store.state.auth.user.studentid}`)
    ).then(
      user => {
        this.pendapatan = user.data()
        if(this.pendapatan == null && this.sulung == false){
          updatePendapatan = true;
          
        }else{
          if(this.pendapatan[this.settings.semester] == null && this.sulung == false)
          updatePendapatan = true;
        }
        
      });

    

    if ( (this.settings.sponsor == true && updatePendapatan == true)) {
      if(updatePendapatan == true){
        if(this.blocking_msg != null)
        this.blocking_msg.push({'title':'Keluarga','status':true})
        else
        this.blocking_msg =[{ 'title': 'Keluarga', 'status': true }]
      }
      
      let myModal = new Modal(document.getElementById('DialogSponsor'));
      myModal.show();
    }
    if (!this.currentUser) {
      this.$router.push('/login');
    }
    
  }
};
</script>


<style lang="scss" scoped>
/* Dropdown styles */
.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-menu {
  position: absolute;
  right: 0;
  z-index: 1000;
  display: none;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 0.875rem;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

.dropdown-menu.show {
  display: block;
}

.dropdown-item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.5rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}

.dropdown-item:hover, .dropdown-item:focus {
  color: #16181b;
  text-decoration: none;
  background-color: #f8f9fa;
}

.dropdown-item.text-danger {
  color: #dc3545;
}

.dropdown-item.text-danger:hover, .dropdown-item.text-danger:focus {
  color: #bd2130;
  background-color: #f8d7da;
}

.dropdown-item ion-icon {
  margin-right: 0.5rem;
  font-size: 1.25rem;
}

/* width */
::-webkit-scrollbar {
  height: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey; 
  border-radius: 10px;
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #cbe2ff; 
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #b30000; 
}
#scroller {
    list-style: none;
    padding: 10px 0;
    margin: 0 7px;
    overflow-x: auto;
    white-space: nowrap;
    overflow-y: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
}
  #scroller li {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    margin: 0 4px;
    padding: 8px 0;
    width: 80px;
    color: #624bff;
    text-align: center;
    text-decoration: none;
  }
.imaged.w64 {
    /* width: 64px !important; */
    height: 3.5rem!important;
    width: 3.5rem!important;
}
.button-rounded{
    width: 2.7rem;
    height: 2.7rem;
    margin-bottom: 3px;
    padding: 5px;
    border-radius: 50%;
    background-color: #cbe2ff;
    object-fit: contain;
    display: block;
    flex-shrink: 0;
}

#scroller .item-app {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-decoration: none;
}

#scroller .caption {
    white-space: normal;
    word-break: break-word;
    text-align: center;
    width: 100%;
}

.btn-primary {
    background: #34547A !important;
    border-color: #34547A !important;
    color: #ffffff !important;
}

.card.rounded-3 {
    background-color: #F3FCFF;
    padding: 4px 2px;
}

.card .card-title {
    font-size: 0.85rem;
}

.main-box .subtitle, .middle-column .subtitle {
    font-size: 1.15rem;
    font-weight: 500;
    color: #ffffff;
}

.middle-column .title {
    font-size: 2.125rem;
    font-weight: 700;
    color: #ffffff;
}

.middle-column .subtitle {
    font-size: 0.85rem;
    font-weight: 500;
    color: #ffffff;
}

.main-box .title {
    color: #ffffff;
}

a.bg-primary, a.bg-primary:hover, a.bg-primary:active {
    background: #002E6E !important;
}

.main-box h1, .main-box h4 {
    margin: 0px 3px 8px 5px;
}

a.bg-warning {
    color: #141515 !important;
}

.profile-menu {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    align-content: center;
    // align-items: center;
    // padding: 0 20px;
    // margin-right: 40px;
}

.profile-menu .btn-icon {
    display: flex;
    width: 60px;
    height: 60px;
    align-items: center;
    border-radius: 200px;
    background-color: #CBE2FF;
    color: #003366;
}

.iconbtm > img {
    max-width: 65px;
}

.item-app {
    margin: 5px 8px;
}

.item-app .caption {
    font-size: 11px;
}

.bg-yellow-12 {
  background: #fff500;
  /* #ff0 */
}

.text-red {
  color: #f44336;
}

.text-bold {
  font-weight: 700;
}

.blink_me {
  animation: blinker 1s linear infinite;
  font-size: 0.875rem;
  line-height: 1.375rem;
  letter-spacing: 0.00714em;
  margin: 0 0 16px;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}

.blink-column {
  padding: 15px 7px 5px 0px;
  text-align: center;
  margin-right: 7px;
}
/* Loading overlay */
.page-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255,255,255,0.85);
  z-index: 2000;
}

.page-loading-overlay .spinner-border {
  width: 3rem;
  height: 3rem;
}

.profiling-title {
  font-size: 1.75rem;
  font-weight: 800;
}

.profiling-message {
  font-size: 1.125rem;
}
</style>